<template id="example-modal">
  <!-- Modal -->
  <div
    class="modal fade"
    id="exampleModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg create-encounter-modal mt-0 mb-0" role="document">
      <div class="modal-content">
        <div class="modal-body p-0">
          <div id="cover-spin" v-if="isrefreshpre"></div>
          <div class="pb-3 pr-5 pl-5 pt-3">
            <div class="" style="max-width: 898px; margin: 0 auto">
              <div class="">
                {{ getPdfUrl }} {{ getdatafromparent }}
                <ul class="print-export new-rule-border">
                  <!-- <li>
                                        <a v-on:click="prespription_exporttoPDF()">
                                            <i class="material-icons export">picture_as_pdf</i>
                                        </a>
                  </li>-->

                  <li>
                    <a v-on:click="onPrintConsolidated()">
                      <i class="material-icons print">print</i>
                    </a>
                  </li>
                  <li style="border-right: 1px solid #eeeeee" v-if="$route.name=='staffdashboard'">
                    <a data-target="#Sendemailp" data-toggle="modal" v-on:click="showEmailPopup()">
                      <i class="material-icons">email</i>
                    </a>
                  </li>
                  <li class="mt-1">
                    <span style="margin-right: 10px">
                      <span v-if="printable_header">{{ $t('Hide') }}</span>
                      <span v-if="!printable_header">{{ $t('Show') }}</span>{{ $t('Header') }} 
                    </span>
                    <label class="container customcheck pr-1">
                      <input
                        type="checkbox"
                        id="printableheader"
                        v-model="printable_header"
                        v-on:click="storeprintableheader()"
                      >
                      <span class="checkmark"></span>
                    </label>
                  </li>
                </ul>
                <div class="close-sec-hold">
                  <button type="button" class="close pl-2" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
              <div class=""
                id="consolidatedprintDiv" :style="{fontFamily:this.$t('fontfam')}"
                v-if="
                  (prescriptionobj ||
                  prescriptionobj != null ||
                  prescriptionobj != undefined)
                "
              >
                {{ getsignaturepath }} {{ getDownloadUrl }}
                <HeaderWrapper :printable="printable_header">
                  <table
                    width="100%"
                    cellspacing="0"
                    cellpadding="0"
                    border="0"
                    style="border-bottom:1px solid #d4d5d7;margin-top:15px"
                    v-if="printable_header"
                  >
                    <tr>
                      <td>
                        <div class="clinic-logo-hold">
                          <img
                            v-if="ClicnicUrllogo!='' && printable_header"
                            :src="ClicnicUrllogo"
                            height="60px"
                            width="Auto"
                          >
                        </div>
                      </td>
                    </tr>
                    <tr style="padding: 0px 40px; background-color: rgb(255, 255, 255);">
                      <td
                        style="padding:15px 30px 10px 0;"
                        class="wrapper1"
                        width="50%"
                        valign="top"
                        align="left"
                      >
                        <table
                          width="100%"
                          cellspacing="0"
                          cellpadding="0"
                          border="0"
                          v-if="prescriptionobj.businesssetup"
                        >
                          <tr>
                            <td valign="top" align="left"
                              style="font-weight:500; line-height:140%;margin:0">
                              <span style="font-weight:500; line-height:140%;margin:0"
                                v-if="prescriptionobj.businesssetup && prescriptionobj.businesssetup.name"
                                v-html="prescriptionobj.businesssetup.name">
                              </span>
                            </td>
                          </tr>
                          <tr v-if="prescriptionobj.businesssetup">
                            <td
                              valign="top"
                              align="left"
                              style="display:block;"
                              v-if="prescriptionobj.businesssetup.location"
                            >
                              <span
                                style="color:#333333;  font-size:14px;font-weight:normal; line-height:140%;"
                                v-if="prescriptionobj.businesssetup.location && prescriptionobj.businesssetup.location.address"
                                v-html="prescriptionobj.businesssetup.location.address"
                              ></span>
                            </td>
                          </tr>
                        </table>
                      </td>
                      <!-- {{prescriptionobj.staffDetails}} -->
                      <td
                        class="wrapper1"
                        width="50%"
                        valign="top"
                        text-align="center"
                        style="padding-bottom:10px;"
                      >
                        <table width="100%" cellspacing="0" cellpadding="0" border="0">
                          <tr>
                            <td valign="top" align="right" style="display:block;">
                              <span
                                align="right"
                                style="color:#212529;  font-size:14px;font-weight:500; line-height:140%;"
                              >
                                <span
                                  v-if="Doctordetailsshow==true && prescriptionobj.staffDetails.title && prescriptionobj.staffDetails.first_name"
                                >{{prescriptionobj.staffDetails.title}} {{prescriptionobj.staffDetails.first_name}} {{prescriptionobj.staffDetails.last_name == null ? "" :prescriptionobj.staffDetails.last_name}}</span>
                              </span>
                              <span
                                style="color: #212529;   font-size: 14px; font-weight: 500; line-height: 140%;width:100%;display: block; "
                              >{{qualification}}</span>
                              <span
                                align="right"
                                style="color:#212529;  font-size:14px;font-weight:500; line-height:140%;"
                              >
                                <span
                                  v-if="prescriptionobj && prescriptionobj.staffDetails && prescriptionobj.staffDetails.category"
                                >{{prescriptionobj.staffDetails.category}}</span>
                              </span>

                              <span
                                align="right"
                                style="color:#212529;  font-size:14px;font-weight:500; line-height:140%;"
                              >
                                <span
                                  v-if=" Doctordetailsshow==true && prescriptionobj.staffDetails && prescriptionobj.staffDetails.registration_number"
                                >{{prescriptionobj.staffDetails.registration_number}}</span>
                              </span>
                              <span
                                align="right"
                                style="color:#212529;  font-size:14px;font-weight:500; line-height:140%;"
                                v-if="Doctordetailsshow==true && location_tephonedetails"
                              >
                                <span>{{location_tephonedetails}}</span></br>
                              </span>
                              <span
                                align="right"
                                style="color:#212529;  font-size:14px;font-weight:500; line-height:140%;"
                                v-if="prescriptionobj.businessappintmenturl && prescriptionobj.businessappintmenturl !='null' && !IsVS"
                              >
                                <!-- <span>{{prescriptionobj.businessappintmenturl}} </span> -->
                                <a
                                  style="color: rgb(33, 37, 41); text-decoration: none;"
                                  target="_blank"
                                  :href="'https://'+prescriptionobj.businessappintmenturl"
                                  title="Mini-site URL"
                                  ref="Mini-site URL"
                                >{{ prescriptionobj.businessappintmenturl.split('/')[0] }}</a>
                              </span>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </HeaderWrapper>
               

                <table cellspacing="0" cellpadding="0" width="100%">
                  <thead>
                    <tr>
                      <td>
                        <!--place holder for the fixed-position header-->
                        <div
                          :class="
                            printable_header
                              ? 'page-header-space'
                              : 'page-header-nospace'
                          "
                        ></div>
                      </td>
                    </tr>
                  </thead>
                  <tbody style="border: 0">
                    <tr>
                      <td>
                        <div class="page">
                          <table
                            width="100%"
                            cellspacing="0"
                            cellpadding="0"
                            border="0"
                            style="border-bottom: solid 1px #ccc !important"
                          >
                            <tr>
                              <td
                                style="border: 0 !important"
                                class="wrapper1"
                                width="70%"
                                valign="top"
                                align="left"
                              >
                                <!-- {{prescriptionobj.patientdetails}} -->
                                <table width="100%" cellspacing="0" cellpadding="0" border="0">
                                  <tr>
                                    <td
                                      valign="top"
                                      align="left"
                                      style="
                                        padding: 10px 0;
                                        border: 0 !important;
                                      "
                                      v-if="prescriptionobj.patientdetails"
                                    >
                                      <span
                                        style="
                                          display: block;
                                          float: left;
                                          width: 100%;
                                        "
                                      >
                                        <span
                                          style="
                                            font-weight: 500;
                                            
                                            font-size: 14px;
                                            line-height: 170%;
                                            width: 136px;
                                            display: inline-block;
                                            float: left;
                                          "
                                          id="label_patientname"
                                        >{{ $t('Patientname') }}</span>
                                        <span
                                          style="
                                            font-weight: 400;
                                            color: #333333;
                                            width: auto;
                                            
                                          "
                                          id="value_patientname"
                                          v-if="
                                            prescriptionobj.patientdetails &&
                                            prescriptionobj.patientdetails.name
                                          "
                                        >
                                          :
                                          {{
                                          prescriptionobj.patientdetails.name
                                          }}
                                        </span>
                                      </span>

                                      <span
                                        style="
                                          display: block;
                                          float: left;
                                          width: 100%;
                                        "
                                      >
                                        <span
                                          style="
                                            font-weight: 500;
                                            
                                            font-size: 14px;
                                            line-height: 170%;
                                            width: 136px;
                                            display: inline-block;
                                            float: left;
                                          "
                                          id="label_registrationno"
                                        >{{ $t('RegistrationNo') }}</span>
                                        <span
                                          style="
                                            font-weight: 400;
                                            color: #333333;
                                            width: auto;
                                            
                                          "
                                          id="value_registrationno"
                                        >
                                          :
                                          {{
                                          prescriptionobj.patientdetails
                                          .patient_RegId
                                          }}
                                        </span>
                                      </span>

                                      <span
                                        style="
                                          display: block;
                                          float: left;
                                          width: 100%;
                                        "
                                      >
                                        <span
                                          style="
                                            font-weight: 500;
                                            
                                            font-size: 14px;
                                            line-height: 170%;
                                            width: 136px;
                                            display: inline-block;
                                            float: left;
                                          "
                                          id="label_agesex"
                                        >{{ $t('AgeSex') }}</span>
                                        <span
                                          style="
                                            font-weight: 400;
                                            color: #333333;
                                            width: auto;
                                            
                                          "
                                          id="value_agesex"
                                        >
                                          :
                                          <span v-if="ageCalculated">{{ ageCalculated }} /</span>
                                          <span
                                            class="c_name"
                                            style="text-transform: capitalize"
                                            v-if="
                                              prescriptionobj.patientdetails
                                                .gender
                                            "
                                          >
                                            {{
                                            prescriptionobj.patientdetails
                                            .gender
                                            }}
                                          </span>
                                        </span>
                                      </span>

                                      <!-- <span style="display:block; float:left; width:100%;">
                                                                            <span style="font-weight:500;  font-size:14px; line-height:170%; width:136px; display:inline-block; float:left;">Phone number</span>
                                                                            <span style="font-weight:400; color:#333333; width:auto; ">: {{prescriptionobj.patientdetails.mobile}}</span>
                                      </span>-->
                                    </td>
                                  </tr>
                                </table>
                              </td>
                              <td
                                class="wrapper1"
                                width="30%"
                                valign="top"
                                text-align="right"
                                style="
                                  padding: 10px 0px 10px 0;
                                  border-bottom: 1px solid #d4d5d7;
                                "
                                 v-if="!IsVS"
                              >
                                <img
                                  v-if="getQRCode()"
                                  :src="getQRCode()"
                                  width="81"
                                  height="80"
                                  style="float: right"
                                >
                                <img
                                  v-else
                                  class="disable-holdsec"
                                  src="https://s3.amazonaws.com/genamet-static-uploads-dev/9c42767e-1559-426b-8c70-b54299e091dd/images/qr-code.gif"
                                  width="81"
                                  height="80"
                                  style="float: right"
                                >
                              </td>
                            </tr>
                          </table>
                          <table
                            width="100%"
                            border="0"
                            cellspacing="0"
                            cellpadding="0"
                            class="wrapper"
                            style="float: left; width: 100%"
                          >
                            <tr>
                              <td
                                align="left"
                                valign="top"
                                bgcolor="#FFFFFF"
                                style="padding: 10px 0 5px 0"
                                class="wrapper"
                              >
                                <span
                                  class="body-text"
                                  style="
                                    
                                    color: #212529;
                                    font-size: 14px;
                                    line-height: 140%;
                                    text-transform: capitalize;
                                  "
                                  v-if="prescriptionobj"
                                >
                                  <span id="label_date" style="font-weight: 500">{{ $t('Date') }}</span>
                                  {{ prescriptionobj.modalencounterdate }}
                                </span>
                              </td>
                            </tr>
                          </table>
                          <br>
                          <!--for the vitals-->
                          <section v-if="show.Vitals && vitals && vitals.length">
                            <div style="margin-top:18px;background:#2959a7;color:#ffffff;font-weight:600;
                                 padding:7px 10px;font-size:15px;">
                              <span id="label_symptoms_summary">Vitals</span>
                            </div>
                            <table
                              style="width:100%;font-size:14px;line-height:20px;border: 1px solid rgb(201, 201, 201);">
                              <tr v-if="vitals && vitals.length" style="width:100%; display:table;">
                                <td align="left" valign="top" bgcolor="#FFFFFF"
                                  style="width:98%; padding:10px 10px 0; display:table-cell;" class="wrapper">
                                  <table border="0" cellspacing="0" cellpadding="0"
                                    style="width:100%; table-layout:fixed;">
                                    <tr v-for="(row, rIdx) in vitalRows" :key="rIdx">
                                      <td v-for="(vital, cIdx) in row" :key="cIdx" align="left" valign="top"
                                        style="width:33.33%; padding:6px 10px 6px 0; font-size:14px; word-break:break-word;">
                                        <template v-if="vital">
                                          <span style="font-weight:600; color:rgb(51,51,51);"
                                            v-html="vital.label"></span>
                                          <span style="font-weight:400;">: {{ vital.value }}</span>
                                        </template>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </section>
                          <!-- BLUE SECTION TITLE -->
                          <section v-if="show.SymptomsAndSummary && encounter">
                            <div style="margin-top:18px;background:#2959a7;color:#ffffff;font-weight:600;
                                 padding:7px 10px;font-size:15px;">
                              <span id="label_symptoms_summary">Symptoms & summary</span>
                            </div>

                            <!-- SUMMARY CONTENT -->
                            <table style="width:100%;font-size:14px;line-height:20px;border: 1px solid rgb(201, 201, 201);">
                              <tr v-if="symptomsText">
                                <td style="padding:0 4px 6px;vertical-align: top;"><strong id="label_symptoms">Symptoms:</strong></td>
                                <td id="value_symptoms">{{ symptomsText }}</td>
                              </tr>
                              <tr v-if="encounter.Doctor_Summary">
                                <td style="padding:0 4px 6px;vertical-align:top;"><strong id="label_summary">Summary:</strong></td>
                                <td id="value_summary">
                                  <div style="margin-top:2px;" v-if="encounter">
                                    <div v-html="encounter.Doctor_Summary"></div>
                                  </div>
                                </td>
                              </tr>
                            </table>
                          </section>

                          <!-- SECTION -->
                          <section v-if="show.ChiefComplaints && chiefComplaintsList && chiefComplaintsList.length">
                            <div style="margin-top:16px;background:#2959a7;color:#ffffff;font-weight:600;
                                   padding:7px 10px;font-size:15px;" id="label_chiefcomplaints">
                              Chief complaints
                            </div>

                            <div
                              style="padding:10px 6px;font-size:14px;line-height:20px;border:1px solid #c9c9c9; background: #f9f9f9;" id="value_chiefcomplaints">
                              {{ chiefComplaintsList }}
                            </div>
                          </section>

                          <section v-if="show.ICD10 && problemsandillnesslist && problemsandillnesslist.length">
                            <div style="margin-top:16px;background:#2959a7;color:#ffffff;font-weight:600;
                                   padding:7px 10px;font-size:15px;">
                              <span id="label_icd10">ICD10</span>
                            </div>

                            <div style="padding:10px 6px;font-size:14px;border:1px solid #c9c9c9; background: #f9f9f9;">
                              <strong id="label_selectedcode">Selected code:</strong>
                              <span
                                v-for="(item, i) in problemsandillnesslist"
                                :key="'icd-block-' + i"
                              >
                                <span
                                  v-for="(code, j) in item.selected_code"
                                  :key="'icd-' + i + '-' + j"
                                >
                                  <span class="icd-code">{{ code.code }}</span>
                                  -
                                  <span :id="`icd_desc_${i}_${j}`">{{ code.name }}</span>
                                  <span>, </span>
                                </span>
                              </span>

                            </div>
                          </section>

                          <!-- PRESCRIPTION -->
                          <section v-if="show.Prescription && prescriptionobj && prescriptionobj.modalresultPrescriptions">


                            <div style="
                                margin-top: 16px;
                                background: #2959a7;
                                color: #ffffff;
                                font-weight: 600;
                                padding: 7px 10px;
                                font-size: 15px;
                            ">
                              <span id="label_prescription_header">Prescription</span>
                            </div>

                            <table style="
                                width: 100%;
                                border-collapse: collapse;
                                font-size: 14px;
                                margin-top: 0;
                            ">
                              <tr style="background: #eef2fb; font-weight: bold">
                                <td style="border: 1px solid #c9c9c9 !important; padding: 7px" id="label_medicine_name">
                                  {{ $t("MedicineName") }}
                                </td>
                                <td style="border: 1px solid #c9c9c9 !important; padding: 7px" id="label_dosage">
                                  {{ $t("Dosage") }}
                                </td>
                                <td style="border: 1px solid #c9c9c9 !important; padding: 7px" id="label_duration">
                                  {{ $t("Duration") }}
                                </td>
                              </tr>

                              <!-- Dynamic Rows -->
                              <tr v-if="prescriptionobj.modalresultPrescriptions"
                                v-for="(val, index) in prescriptionobj.modalresultPrescriptions" :key="index">
                                <!-- Medicine Name -->
                                <td style="border: 1px solid #c9c9c9 !important; padding: 7px">
                                  <span v-if="val.drug_details && val.drug_details.Formulation"
                                    style="text-transform: uppercase">
                                    {{ val.drug_details.Formulation }}&nbsp;
                                  </span>

                                  <span v-else-if="val.medicine_type && val.medicine_type.name"
                                    style="text-transform: uppercase">
                                    {{ val.medicine_type.name }}&nbsp;
                                  </span>

                                  <span  v-if="
                                    val.drug_details &&
                                    val.drug_details.hasOwnProperty('CIMSDESC') &&
                                    val.drug_details.CIMSDESC
                                  " style="font-weight: 500" :id="`med_name_${index}`">
                                    {{ val.drug_details.CIMSDESC }}
                                  </span>

                                  <span v-else-if="
                                    val.drug_details &&
                                    !val.drug_details.hasOwnProperty('CIMSDESC')
                                  " style="font-weight: 500">
                                    {{ val.drug_details }}
                                  </span>

                                  <span v-if="val.strength || val.strength_units">
                                    {{ val.strength }} {{ val.strength_units }}
                                  </span>
                                </td>

                                <!-- Dosage -->
                                <td style="border: 1px solid #c9c9c9 !important; padding: 7px">
                                  <!-- SOS only -->
                                  <span v-if="
                                    !val.direction_morning &&
                                    !val.direction_afternoon &&
                                    !val.direction_evening &&
                                    !val.direction_night &&
                                    val.direction_sos
                                  ">
                                    {{ val.tables_count }} {{ $t("SOS") }}
                                  </span>

                                  <!-- Normal schedule -->
                                  <span v-else>
                                    <span v-if="val.direction_morning" :id="`med_dosage_morning_${index}`">
                                      {{ val.tables_count }} {{ $t("Breakfast") }}
                                    </span>
                                    <span v-if="val.direction_afternoon"  :id="`med_dosage_afternoon_${index}`">
                                      {{ val.tables_count }} {{ $t("Lunch") }}
                                    </span>
                                    <span v-if="val.direction_evening" :id="`med_dosage_evening_${index}`">
                                      {{ val.tables_count }} {{ $t("Evening") }}
                                    </span>
                                    <span v-if="val.direction_night" :id="`med_dosage_night_${index}`">
                                      {{ val.tables_count }} {{ $t("Dinner") }}
                                    </span>
                                    <span v-if="val.direction_sos" :id="`med_dosage_sos_${index}`">
                                      {{ val.tables_count }} {{ $t("SOS") }}
                                    </span>
                                  </span>

                                  <br />

                                  <span style="font-size: 12px" :id="`med_food_${index}`">
                                    (
                                    {{ val.direction_preffered == 1
                                      ? $t("Afterfood")
                                      : $t("Beforefood") }}
                                    )
                                  </span>
                                </td>

                                <!-- Duration -->
                                <td style="border: 1px solid #c9c9c9 !important; padding: 7px">
                                  <span v-if="val.course_period" :id="`med_duration_${index}`">
                                    {{ val.course_period }} {{ $t("days") }}
                                  </span>
                                  <br />
                                  <span v-if="val.course_qty_pharmacy" style="font-size: 12px">
                                    ({{ $t("Total") }} : {{ val.course_qty_pharmacy }})
                                  </span>
                                </td>
                              </tr>

                              <!-- No Data -->
                              <tr v-if="!prescriptionobj.modalresultPrescriptions">
                                <td colspan="3" style="padding: 15px; text-align: center">
                                  {{ $t("Noprescriptionshavebeensuggested.") }}
                                </td>
                              </tr>
                            </table>
                          </section>
                          <!-- INVESTIGATION -->
                          <section v-if="show.Investigations && investigationobj &&
                                  Array.isArray(investigationobj.modalresultInvestigation) &&
                                  investigationobj.modalresultInvestigation.length">


                            <div style="
                                margin-top: 16px;
                                background: #2959a7;
                                color: #ffffff;
                                font-weight: 600;
                                padding: 7px 10px;
                                font-size: 15px;
                              ">
                              <span id="label_investigations_header">Investigations ordered</span>
                            </div>

                            <!-- Investigation List -->
                            <div v-if="investigationobj.modalresultInvestigation &&
                              investigationobj.modalresultInvestigation.length > 0">
                              <div
                                v-for="(item, index) in investigationobj.modalresultInvestigation"
                                :key="index"
                                style="
                                  padding: 10px 6px;
                                  font-size: 14px;
                                  border: 1px solid #c9c9c9;
                                  border-top: none;
                                  background: #f9f9f9;
                                "
                              >
                                <div :id="'investigation_name_' + index" style="font-weight: 500;">
                                  {{ item.investigation_name }}
                                </div>

                                <div v-if="item.notes" style="font-size: 13px; margin-top: 4px;">
                                  <span :id="'investigation_note_label_' + index">Notes:</span>
                                  <span :id="'investigation_note_' + index">{{ item.notes }}</span>
                                </div>
                              </div>

                            </div>
                          </section>
                          <!-- IMMUNISATION -->
                          <section v-if="show.Immunization && immunizationobj && immunizationobj.modalresultImmunization &&
                                immunizationobj.modalresultImmunization.length > 0">


                            <div style="
                                margin-top: 16px;
                                background: #2959a7;
                                color: #ffffff;
                                font-weight: 600;
                                padding: 7px 10px;
                                font-size: 15px;
                              ">
                               <span id="label_immunization_header">Immunization</span>
                            </div>

                            <!-- Chief Complaints (if any) -->
                            <div v-if="immunizationobj.modalresultChiefComplaints &&
                              immunizationobj.modalresultChiefComplaints.length > 0"
                              style="padding:10px;border:1px solid #c9c9c9;border-top:none;">
                              {{ immunizationobj.modalresultChiefComplaints.join(', ') }}
                            </div>

                            <table v-if="immunizationobj.modalresultImmunization &&
                              immunizationobj.modalresultImmunization.length > 0"
                              style="width:100%;border-collapse:collapse;font-size:14px;">
                              <tr style="background:#eef2fb;font-weight:bold;">
                                <td style="border:1px solid #c9c9c9 !important;padding:7px;" id="label_vaccine_name">{{ $t('VaccineName') }}</td>
                                <td style="border:1px solid #c9c9c9 !important;padding:7px;" id="label_due_date">{{ $t('Duedate') }}</td>
                                <td style="border:1px solid #c9c9c9 !important;padding:7px;" id="label_route">{{ $t('Route') }}</td>
                                <td style="border:1px solid #c9c9c9 !important;padding:7px;" id="label_site">{{ $t('Site') }}</td>
                                <td style="border:1px solid #c9c9c9 !important;padding:7px;" id="label_note">{{ $t('Note') }}</td>
                              </tr>

                              <!-- Vaccine Row -->
                              <tr v-for="(val, index) in immunizationobj.modalresultImmunization"
                                :key="'vaccine-' + index">
                                <td style="border:1px solid #c9c9c9 !important;padding:7px;" :id="'vaccine_name_' + index">
                                  {{ val.selected_vaccine_name }}
                                </td>
                                <td style="border:1px solid #c9c9c9 !important;padding:7px;">
                                  {{ val.selected_duedate }}
                                </td>
                                <td style="border:1px solid #c9c9c9 !important;padding:7px;" :id="'route_' + index">
                                  {{ val.selected_route || 'N/A' }}
                                </td>
                                <td style="border:1px solid #c9c9c9 !important;padding:7px;" :id="'site_' + index">
                                  {{ val.site_name || 'N/A' }}
                                </td>
                                <td style="border:1px solid #c9c9c9 !important;padding:7px;" :id="'note_' + index">
                                  {{ val.notes || 'N/A' }}
                                </td>
                              </tr>

                              <!-- Schedule Row -->
                              <tr v-for="(val, index) in immunizationobj.modalresultImmunization"
                                :key="'schedule-' + index"
                                v-if="val.defaultschedule || (val.schedule && val.schedule.length)">
                                <td colspan="5" style="border:1px solid #c9c9c9 !important;padding:7px;">
                                  <!-- Default schedule -->
                                  <div v-if="val.defaultschedule">
                                    <input type="radio" disabled />
                                    {{ val.defaultschedule }}
                                    &nbsp;&nbsp;
                                    {{ val.vaccinedosage || $t('NA') }}
                                    &nbsp;&nbsp;
                                    {{ val.selected_duedate }}
                                  </div>

                                  <!-- Additional schedules -->
                                  <div v-for="(item, i) in val.schedule" :key="'item-' + i">
                                    <input type="radio" disabled />
                                    {{ item.schedule_due_date }}
                                    &nbsp;&nbsp;
                                    {{ item.dosage || $t('NA') }}
                                    &nbsp;&nbsp;
                                    {{ item.schedulecompleteddate || $t('NA') }}
                                  </div>
                                </td>
                              </tr>
                            </table>
                          </section>

                          <div
                            id="prescriptionFooterNote1"
                            class="prescriptionFooterNotehold"
                            v-if="
                              prescriptionFooterNote1 &&
                              prescriptionFooterNote1.ehr_note_value
                            "
                            v-html="prescriptionFooterNote1.ehr_note_value"
                          ></div>
                             <table
                            width="100%"
                            style="border-bottom: 1px solid #d4d5d7"
                            border="0"
                            cellspacing="0"
                            cellpadding="0"
                            align="center"
                          >
                            <tr v-if="Doctordetailsshow==true">
                              <td
                                align="right"
                                valign="top"
                                bgcolor="#FFFFFF"
                                style="padding: 30px 0 15px 0; margin: 0"
                              >
                                <img
                                  v-if="fileUrl != ''"
                                  :src="fileUrl"
                                  height="120px"
                                  width="Auto"
                                >

                                <span
                                  style="
                                    width: 100%;
                                    text-align: right;
                                    display: block;
                                    padding: 10px 0;
                                  "
                                  span id="label_sign_doctorname"
                                  v-if="
                                    prescriptionobj &&
                                    prescriptionobj.staffDetails && tenantId!='05c7079f-d889-4a40-8fac-0ae75c445c15'
                                  "
                                >
                                  {{ prescriptionobj.staffDetails.title }}
                                  {{ prescriptionobj.staffDetails.first_name }}
                                  {{ prescriptionobj.staffDetails.last_name }}
                                </span>
                                <table
                                  width="100%"
                                  v-if="tenantId=='05c7079f-d889-4a40-8fac-0ae75c445c15'"
                                >
                                  <tr>
                                    <td align="right">
                                      <p
                                        style="margin-bottom:5px;font-weight:500;"
                                      >Dr. Swati Rajagopal, KMC #:61458</p>
                                      <p
                                        style="margin-bottom:5px;font-weight:500;"
                                      ></p>
                                      <p
                                        style="margin-bottom:5px;font-weight:500;"
                                      >Arista Health Clinic</p>
                                      <p
                                        style="margin-bottom:5px;font-weight:500;"
                                      >Aster CMI Hospital</p>
                                    </td>
                                  </tr>
                                </table>

                                <!-- <span style="width:100%; text-align:right; display: block;" v-if="prescriptionobj && prescriptionobj.staffDetails && prescriptionobj.staffDetails.category && prescriptionobj.staffDetails.category && !prescriptionobj.footernote1">Consultant - {{prescriptionobj.staffDetails.category}}</span> -->
                                <table
                                  v-if="prescriptionobj.footernote1"
                                  width="100%"
                                  cellpadding="0"
                                  cellspacing="0"
                                >
                                  <tr>
                                    <td align="center" valign="top">
                                      <p
                                        v-html="prescriptionobj.footernote1"
                                        style="
                                          margin: 10px 0 0;
                                          font-size: 12px;
                                        "
                                      ></p>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                          </table>
                          

                         
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td>
                        <!--place holder for the fixed-position footer-->
                        <div
                          :class="
                            printable_header
                              ? 'page-footer-space'
                              : 'page-footer-nospace'
                          "
                        ></div>
                      </td>
                    </tr>
                  </tfoot>
                </table>
                <div :class="printable_header ? 'page-footer' : 'no-footer'">
                  <table width="100%" v-if="printable_header">
                    <tr>
                      <td align="center" style="padding: 10px 0">
                        <span
                        id="label_footer_disclaimer"
                          class="body-text"
                          style="
                            
                            color: #212529;
                            font-size: 13px;
                            font-weight: 500;
                            font-style: normal;
                          "
                        > {{ $t('Thisdocumentisdigitallysignedandhencenomanualsignatureisrequired') }}
                          
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td align="center">
                        <span style="font-size: 13px; color: #aaa">{{ $t('Poweredby') }} &nbsp;</span>
                        <a
                          href="https://www.genamet.com/"
                          target="_blank"
                          style="text-decoration: none"
                        >
                          <span
                            style="
                              font-size: 13px;
                              color: rgb(0, 86, 224);
                              text-decoration: none;
                            "
                          > www.genamet.com</span>
                        </a>
                      </br>
                       <a href="#" style="margin-right: 10px">
                          <img
                            style="padding-top: 10px"
                            src="https://s3.amazonaws.com/genamet-static-uploads-dev/9c42767e-1559-426b-8c70-b54299e091dd/images/powered-genamet.png"
                          >
                        </a>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- VIew sendEmail popup -->

    <!-- End master print popup-->
    <div v-if="showhideemailpopup">
      <div
        class="modal fade"
        id="Sendemailp"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          class="modal-dialog grt-md"
          role="document"
          style="
            width: 570px;
            background: #fff;
            border-radius: 3px;
            -webkit-border-radius: 3px;
          "
        >
          <div class="modal-content" style="padding: 20px 50px">
            <div class="modal-header">
              <h5 style="margin: 0px auto">{{ $t('SendEmail') }}</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                style="top: 10px"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <ul class="list-select" style="margin-bottom: 0px">
                <li class="data-hold" v-for="item in emaillist" :key="item">
                  <span>{{ item }}</span>
                  <a @click.prevent="removeEmail(item)" href="#">X</a>
                </li>
                <li>
                  <input
                    type="text"
                    v-model="customemail"
                    @keyup.enter="addemail(customemail)"
                    class="form-control"
                    placeholder="Type in email address & press enter"
                  >
                </li>
              </ul>
              <div
                v-if="errorsemail"
                style="
                  color: rgba(243, 69, 58, 0.8);
                  font-size: 13px;
                  font-weight: 500;
                  display: block !important;
                "
              >{{ errorsemail }}</div>
            </div>
            <div
              class="modal-footer"
              v-if="emaillist && emaillist.length > 0"
              style="padding-top: 0px"
            >
              <button
                type="button"
                class="primary-btn ripple pull-right"
                data-dismiss="modal"
                aria-label="Close"
                @click="senddetailsoveremail()"
              >{{ $t('Send') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import rest_service from "@/api/rest_service";
import { mapActions, mapGetters, Store } from "vuex";
import Axios from "axios";
import moment from "moment";
const staff_sub_url = "/staff/getselectedprojection";
import commonhelper from "@/common/commonhelper";
import InvoiceReceiptApi from "../../api/InvoiceReceipt.js";
import i18n from "@/plugin/i18n";
import HeaderWrapper from "@/components/Headers/HeaderWrapper";

export default {
  mixins: [commonhelper],
  props: ["prescriptionobj","investigationobj","immunizationobj","chiefComplaintsList","encounter","problemsandillnesslist"],
  components: {
    // masterprint: () => import("@/components/Print/Masterprint.vue"),
    HeaderWrapper
  },
  data() {
    return {
      consolidatesprintsections:[],
      headerdisplaysetting:"provider",
      //symptomsText:"",
      patientemail: "",
      prescriptionobject: {},
      showhideemailpopup: false,
      emaillist: [],
      patientmobile: "",
      customemail: "",
      errorsemail: null,
      qualification: "",
      showModal: false,
      //getstafflistbyid:[],
      getdownloadfileUrl: "",
      signatureFlag: "staffSign",
      fileUrl: "",
      //fileUrl: "https://upload.wikimedia.org/wikipedia/commons/5/56/Autograph_of_Benjamin_Franklin.svg",
      tenantId: "14a552c6-9bf9-4283-8388-fb30c272a114",
      patientdetails: [],
      isrefreshpre: true,
      foldername: "",
      printable_header: false,
      location_tephonedetails: null,
      ClicnicUrllogo: null,
      ageCalculated: null,
      qrcodedata: null,
      prescriptionFooterNote1: {},
      Doctordetailsshow: true,
      langselected: "en",
      IsVS: false,
    };
  },
  created() {
    //rest_service.getQRCodeData();
    this.changeLocale();
    this.emaillist = [];
    this.tenantId = localStorage.getItem("tenantid");
  },
  watch: {
    customemail: function (val, oldVal) {
      this.errorsemail = "";
    },
  },
  mounted() {
    let business_data = localStorage.getItem("tenantbusinesssetup");
    if (business_data) {
      var Jsonbusinessdata = JSON.parse(business_data);
      if (Jsonbusinessdata.isVS && !Jsonbusinessdata.vs_with_standard_features) { this.IsVS = Jsonbusinessdata.isVS; }
      if (Jsonbusinessdata.printheadersetting) { this.headerdisplaysetting = Jsonbusinessdata.printheadersetting }
      if (Jsonbusinessdata.consolidatedPrntSections) { this.consolidatesprintsections = Jsonbusinessdata.consolidatedPrntSections; }
    }
  },
  computed: {
    ...mapGetters([
      //"gett_businesssetup",
      "gett_pdfurl",
    ]),
    // keys match the ConsolidatedPrintSectionType enum names
    show() {
      const configured = this.consolidatesprintsections;
      const all = !configured || configured.length === 0;
      const on = (key) => all || configured.includes(key);

      return {
        Vitals: on("Vitals"),
        SymptomsAndSummary: on("SymptomsAndSummary"),
        Prescription: on("Prescription"),
        Investigations: on("Investigations"),
        ICD10: on("ICD10"),
        Immunization: on("Immunization"),
        ChiefComplaints: on("ChiefComplaints"),
      };
    },
    vitalRows() {
      const rows = [];
      for (let i = 0; i < this.vitals.length; i += 3) {
        const row = this.vitals.slice(i, i + 3);
        while (row.length < 3) row.push(null); // pad so columns stay aligned
        rows.push(row);
      }
      return rows;
    },
    vitals() {
      // 1. Pick the latest saved entry from encounter.Vitals
      const entries =
        this.encounter && Array.isArray(this.encounter.Vitals)
          ? this.encounter.Vitals
          : [];
      if (!entries.length) return [];

      const time = (e) => {
        const t = new Date(e && e.Vitals_CreatedDate).getTime();
        return isNaN(t) ? 0 : t;
      };
      const latest = entries.reduce((a, b) => (time(b) >= time(a) ? b : a));

      // 2. Normalise that entry's field array (string or array)
      const raw = latest && latest.Vitals ? latest.Vitals : [];
      let vitalFormArr = [];
      if (typeof raw === "string") {
        try {
          vitalFormArr = JSON.parse(raw) || [];
        } catch (e) {
          vitalFormArr = [];
        }
      } else if (Array.isArray(raw)) {
        vitalFormArr = raw;
      }

      // 3. Same as before from here
      const hasVitalData = vitalFormArr.some(
        (field) =>
          field.type === "number" &&
          field.value &&
          field.value.length &&
          field.value[0] !== "" &&
          field.value[0] !== null &&
          field.value[0] !== undefined
      );
      if (!hasVitalData) return [];

      const isUnitField = (name) => /-unit(-selected)?$/.test(name || "");
      const getValueBase = (name) => (name || "").replace(/-value$/, "");
      const getUnitBase = (name) =>
        (name || "").replace(/-unit-selected$/, "").replace(/-unit$/, "");

      const getSelectedLabel = (field) => {
        const selected = (field.values || []).find((v) => v.selected);
        return selected ? selected.label : "";
      };

      const unitsMap = {};
      vitalFormArr.forEach((field) => {
        if (field.name && isUnitField(field.name) && field.values) {
          const label = getSelectedLabel(field);
          if (label) unitsMap[getUnitBase(field.name)] = label;
        }
      });

      const vitals = [];
      vitalFormArr.forEach((field) => {
        if (field.type === "header") return;
        if (field.name && isUnitField(field.name)) return;
        if (field.name && field.name.toLowerCase().includes("pregnant")) return;
        if (
          field.type === "radio-group" &&
          field.label &&
          field.label.toLowerCase().includes("pregnant")
        )
          return;

        let label = field.label ? this.trimHtml(field.label) : "";
        if (field.name === "min-blood-pressure") {
          label = this.$t("Systolicbloodpressure");
        } else if (field.name === "max-blood-pressure") {
          label = this.$t("Diastolicbloodpressure");
        }

        const unit = unitsMap[getValueBase(field.name)];
        if (unit) label = `${label} (${unit})`;

        let value = "";
        if (field.type === "number" && field.value && field.value.length) {
          value = field.value[0];
        } else if (field.type === "select" || field.type === "radio-group") {
          value = getSelectedLabel(field);
        } else if (field.type === "textarea" && field.value) {
          value = this.trimHtml(field.value);
        }

        if (value !== "" && value !== null && value !== undefined) {
          vitals.push({ label, value });
        }
      });

      return vitals;
    },
    symptomsText() {
      if (
        !this.encounter ||
        !Array.isArray(this.encounter.Quick_Notes)
      ) {
        return "";
      }

      const notes = this.encounter.Quick_Notes;

      const symptomObj = notes.find(function (q) {
        return q && q.name === "quicknote_symptomsselected";
      });

      if (
        !symptomObj ||
        !Array.isArray(symptomObj.value)
      ) {
        return "";
      }

      return symptomObj.value.join(", ");
    },
    problemsandillness() {
      if (!Array.isArray(this.problemsandillnesslist)) return "";

      return this.problemsandillnesslist
        .flatMap(item =>
          Array.isArray(item.selected_code)
            ? item.selected_code.map(
              code => `${code.code} - ${code.name}`
            )
            : []
        )
        .join(", ");
    },
    processItems() {
      return this.prescriptionobj.staffDetails.category_list
        .map((item) => item.category)
        .join(", ");
    },
    formattedDate() {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are zero-based
      const year = today.getFullYear();
      return `${day}/${month}/${year}`;
    },
    getsignaturepath: function () {
      var signaturefilename = "";
      if (this.prescriptionobj.staffDetails) {
        if (this.prescriptionobj.staffDetails.signature_pic_file_name != null) {
          signaturefilename =
            this.prescriptionobj.staffDetails.signature_pic_file_name;
          this.foldername =
            this.prescriptionobj.staffDetails.tenant_id +
            this.$store.state.helper.tenant_s3upload_Folders
              .signatureDownloadPath +
            signaturefilename;
          this.signatureFlag = "staffSign";
          if (localStorage.getItem("SignatureExpiryDate")) {
            var Expirydate = localStorage.getItem("SignatureExpiryDate");
            var today = new Date();
            Expirydate = new Date(Expirydate);
            Expirydate = Expirydate.toLocaleDateString();
            today = today.toLocaleDateString();
            if (Expirydate > today) {
              if (localStorage.getItem("SignatureUrl")) {
                this.fileUrl = this.getdownloadfileUrl =
                  localStorage.getItem("SignatureUrl");
                this.isrefreshpre = false;
              } else {
                this.getUrlFromS3Bucket(this.foldername);
              }
            } else {
              this.getUrlFromS3Bucket(this.foldername);
            }
          } else {
            this.getUrlFromS3Bucket(this.foldername);
          }
        } else {
          this.isrefreshpre = false;
          //this.fileUrl="";
          this.signatureFlag = "";
        }
      }
    },
    getDownloadUrl() {
      //this.fileUrl="";
      if (
        this.getdownloadfileUrl &&
        this.getdownloadfileUrl.length > 0 &&
        this.getdownloadfileUrl.indexOf(
          "documents-gen-ehr-dev.s3.amazonaws.com"
        )
      ) {
        if (
          this.signatureFlag == "staffSign" &&
          this.signatureFlag.length > 0
        ) {
          this.fileUrl = this.getdownloadfileUrl;
        }
      }
    },
    getPdfUrl() {
      if (this.gett_pdfurl && this.prescriptionobj.PdfDownload) {
        var win = window.open(this.gett_pdfurl, "_blank");
        if (win) {
          //Browser has allowed it to be opened
          win.focus();
          this.ispdfview = false;
        } else {
          //Browser has blocked it
          alert("Please allow popups for this website");
        }
        this.prescriptionobj.PdfDownload = false;
      }
    },
    getdatafromparent() {
      if (
        this.prescriptionobj &&
        this.prescriptionobj.provider_id &&
        this.prescriptionobj.Dashboardstaff == "Dashboardstaff" &&
        (!this.prescriptionobj.staffDetails ||
          !this.prescriptionobj.staffDetails.category_list ||
          this.prescriptionobj.staffDetails.unique_id !=
          this.prescriptionobj.provider_id)
      ) {
        this.getstaffbyid(this.prescriptionobj.provider_id);
      }
      if (
        this.prescriptionobj &&
        this.prescriptionobj.Doctordetailsshow == false
      ) {
        this.Doctordetailsshow = this.prescriptionobj.Doctordetailsshow;
      }

      this.setCategory();
      this.printable_header = this.$store.state.helper.printable_header;
      if (localStorage.getItem("AppLocList")) {
        var locationlist = JSON.parse(localStorage.getItem("AppLocList"));
        if (localStorage.slctdappfacltaddr) {
          var selectedAppFacility = JSON.parse(localStorage.slctdappfacltaddr);
          locationlist.forEach((x) => {
            if (x.unique_id === selectedAppFacility.unique_id) {
              this.location_tephonedetails = x.clinic_contact_numbers;
              //this.location_address= x.address;
            }
          });
        }
      }
      if (!this.location_tephonedetails) {
        this.location_tephonedetails =
          this.prescriptionobj.staffDetails &&
            this.prescriptionobj.staffDetails.mobile
            ? this.prescriptionobj.staffDetails.mobile
            : "";
      }
      if (
        this.prescriptionobj &&
        this.prescriptionobj.modalresultPrescriptions
      ) {
        this.prescriptionobj.modalresultPrescriptions.forEach((element) => {
          var datechecking = moment(element.start_date).format("DD-MM-YYYY");
          var currentdate = new Date();
          var tomarrowdate = new Date();
          tomarrowdate.setDate(tomarrowdate.getDate() + 1);
          currentdate = moment(currentdate).format("DD-MM-YYYY");
          tomarrowdate = moment(tomarrowdate).format("DD-MM-YYYY");
          if (currentdate == datechecking) {
            element.showstartdate =
              "Today" +
              " (" +
              moment(element.start_date).format("DD-MM-YYYY") +
              ")";
          } else if (tomarrowdate == datechecking) {
            element.showstartdate =
              "Tomorrow" +
              " (" +
              moment(element.start_date).format("DD-MM-YYYY") +
              ")";
          } else {
            element.showstartdate = moment(element.start_date).format(
              "DD-MM-YYYY"
            );
          }
          if (element.end_date) {
            element.showenddate = moment(element.end_date).format("DD-MM-YYYY");
          } else {
            var date = moment(element.showstartdate, "DD-MM-YYYY").add(
              parseInt(element.course_period - 1),
              "days"
            );
            element.showenddate = moment(date).format("DD-MM-YYYY");
          }
          if (this.OnlyNumeric(element.tables_count)) {
            element.tabletcountperday = element.direction_morning
              ? parseInt(element.tables_count)
              : 0;
            element.tabletcountperday =
              parseInt(element.tabletcountperday) +
              (element.direction_afternoon
                ? parseInt(element.tables_count)
                : 0);
            element.tabletcountperday =
              parseInt(element.tabletcountperday) +
              (element.direction_evening ? parseInt(element.tables_count) : 0);
            element.tabletcountperday =
              parseInt(element.tabletcountperday) +
              (element.direction_night ? parseInt(element.tables_count) : 0);
            element.tabletcountperday =
              parseInt(element.tabletcountperday) +
              (element.direction_sos ? parseInt(element.tables_count) : 0);

            element.tabletscalcutation = false;
          } else {
            element.tabletcountperday = element.tables_count;
            element.tabletscalcutation = true;
          }
        });
      }
      if (
        this.immunizationobj &&
        this.immunizationobj.modalresultImmunization
      ) {
        this.immunizationobj.modalresultImmunization.forEach((element) => {
          element.selected_vaccine_name =
            element.immunizationData.selected_vaccine_name;
          element.selected_duedate = element.immunizationData.selected_duedate;
          element.selected_route = element.immunizationData.selected_route;
          element.site_name = element.immunizationData.site_name;
          element.notes = element.immunizationData.notes;
          element.defaultschedule = element.immunizationData.defaultschedule;
          element.vaccinedosage = element.immunizationData.vaccinedosage;
          element.schedule = [];
          element.immunizationData.schedule.forEach((ele) => {
            // element.schedule.schedule_due_date=ele.schedule_due_date;
            // element.schedule.dosage=ele.dosage;
            element.schedule.push(ele);
            // element.schedule.dosage=ele.dosage;
          });
        });
      }
      if (localStorage && localStorage.ClicnicUrllogo) {
        this.ClicnicUrllogo = localStorage.ClicnicUrllogo;
      } else {
        if (
          this.$store.state.helper.st_s3bucket_name &&
          this.$store.state.helper.tenant_id &&
          this.$store.state.helper.st_business_logo_folder &&
          this.$store.state.helper.clinicLogoFileName
        ) {
          if (!this.$store.state.helper.clinicLogoUrl) {
            var logoURl =
              process.env.VUE_APP_S3_BUCKET_PUBLIC_NAME +
              this.$store.state.helper.tenant_id +
              process.env.VUE_APP_BUSINESS_LOGO_FOLDER +
              this.$store.state.helper.clinicLogoFileName;
            this.ClicnicUrllogo = this.$store.state.helper.clinicLogoUrl =
              logoURl;
            if (!localStorage.ClicnicUrllogo) {
              localStorage.setItem("ClicnicUrllogo", logoURl);
            }
          } else {
            this.ClicnicUrllogo = this.$store.state.helper.clinicLogoUrl;
            if (!localStorage.ClicnicUrllogo) {
              localStorage.setItem("ClicnicUrllogo", this.ClicnicUrllogo);
            }
          }
        }
      }
      if (this.prescriptionobj.provider_id) {
        this.getstaffname(this.prescriptionobj.provider_id);
        this.getPrescriptionStaticContent(this.prescriptionobj.provider_id);
      }
    },
  },
  methods: {
    trimHtml(htmlTxt) {
      var div = document.createElement("div");
      div.innerHTML = htmlTxt;
      return div.innerText;
    },
    changeLocale() {
      if (localStorage.getItem("is_language") == "true") {
        if (localStorage.getItem("Language") != "null") {
          var lang = JSON.parse(localStorage.getItem("Language"));
          i18n.locale = lang.languageCode;
        } else {
          i18n.locale = this.langselected;
        }
      } else {
        i18n.locale = this.langselected;
      }
    },
    getappointment(appointmentid) {
      var self = this;
      
      InvoiceReceiptApi.getappointment(appointmentid).then(
        (appointmentdetails) => {
          
          if (appointmentdetails.data) {
            self.patientemail =
              appointmentdetails.data.result.patient_details.email;
            if (self.patientemail) {
              self.emaillist.push(self.patientemail.toLowerCase());
            }
          }
        }
      );
    },

    showEmailPopup() {
      this.emaillist = [];
      this.getappointment(this.$parent.appointmentdetails.unique_id);
      if (this.emaillist != null) {
        if (this.emaillist.length > 1) {
          while (this.emaillist.length > 1) {
            //     // Remove elements from array
            this.emaillist.pop();
          }
        }
      }
      this.showhideemailpopup = true;
    },

    senddetailsoveremail() {
      // this.showmasterprintpopup("email");
      this.onEmailData();
      this.showhideemailpopup = false;
      //this.resetEmailparams();
    },

    addemail(val) {
      if (this.validateEmail(val.toLowerCase())) {
        if (this.emaillist.indexOf(val.toLowerCase()) > -1) {
          this.errorsemail = "This email id is already added";
        } else {
          this.emaillist.push(val.toLowerCase().trim());
          this.customemail = "";
        }
      }
    },
    validateEmail(val) {
      let re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (val && val.length > 0) {
        if (!re.test(val.toLowerCase())) {
          this.errorsemail = "Please provide a valid email address";
          return false;
        } else {
          this.errorsemail = null;
          return true;
        }
      }
    },
    removeEmail(val) {
      this.emaillist = this.emaillist.filter((e) => e !== val.toLowerCase());
    },
    resetEmailparams() {
      this.showhideemailpopup = false;
      this.emaillist = [];
      this.customemail = "";
    },
    getstaffname(staff_id) {
      
      this.getpatientdetails(this.prescriptionobj.patientdetails.unique_id);
      let self = this;
      var staff_fullname = "";
      var masterdata = {
        id: staff_id,
        projectionitems: "first_name,educationalQualificationsObjectArray",
      };
      rest_service
        .get("/staff/getselectedprojection", localStorage.tenantid, masterdata)
        .then((respo) => {
          if (respo.data && respo.data.result) {
            self.staff_data = respo.data.result;
            this.qualification = "";
            
             if (
              Array.isArray(self.staff_data.educationalQualificationsObjectArray) &&
              self.staff_data.educationalQualificationsObjectArray.length > 0
            ) {
              for (
                var i = 0;
                i < self.staff_data.educationalQualificationsObjectArray.length;
                i++
              ) {
                self.qualification +=
                  self.staff_data.educationalQualificationsObjectArray[
                    i
                  ].educationalQualifications;
                if (
                  i <
                  self.staff_data.educationalQualificationsObjectArray.length -
                    1
                ) {
                  self.qualification += ",";
                } else {
                  self.qualification = self.qualification;
                }
              }
            }
            if (self.staff_data.first_name && self.staff_data.last_name) {
              self.vitals_updated_doctor =
                self.staff_data.first_name + self.staff_data.last_name;
            } else {
              self.vitals_updated_doctor = self.staff_data.first_name;
            }
          } else {
            staff_fullname = "";
          }
          // return staff_fullname;
        });

      return staff_fullname;
    },
    ...mapActions(["ac_export_to_pdf", "ac_getbusinesssetup"]),
    OnlyNumeric(data) {
      var re = /^[0-9]*$/;
      var re2 = re.test(data);
      if (re2) return true;
      else return false;
    },
    calcAge(dateString) {
      var birthday = +new Date(dateString);
      return ~~((Date.now() - birthday) / 31557600000);
    },
    prespription_exporttoPDF() {
      this.prescriptionobj.PdfDownload = true;
      var content = document.getElementById(
        "consolidatedprintDiv"
      ).innerHTML;
      content = content.split('"').join("'");
      content = content.replace("//", "/\\/");
      content = content.replace(/(\r\n\t|\n|\r\t)/gm, "");
      this.ac_export_to_pdf(content);
    },
    storeprintableheader() {
      this.$store.state.helper.printable_header =
        document.getElementById("printableheader").checked;
    },
    onEmailData() {
      if (document.getElementById("consolidatedprintDiv")) {
        
        var self = this;
        let doctorname = "";
        // if(this.businessandotherdetails && this.businessandotherdetails.staffDetails && this.businessandotherdetails.staffDetails.first_name){
        //  doctorname = (this.businessandotherdetails.staffDetails.title?this.businessandotherdetails.staffDetails.title+" ":"")+(this.businessandotherdetails.staffDetails.first_name) +(this.businessandotherdetails.staffDetails.last_name?" "+this.businessandotherdetails.staffDetails.last_name:"");
        // }
        var style = "";
        if (self.tenantId == "44acd54f-5f3b-4567-a1a0-ca8e25d8ddc9") {
          style =
            ".page-header .clinic-logo-hold { top: 5px;left: 20px;position:absolute;}";
        }
        if(self.headerdisplaysetting=='hospital'){
          style=".page-header{min-height:110px;}.title-details{display:table;grid-gap:60px;text-align:center;align-items:center} .title-details>div{display:table-cell;width:auto;float:left;}.title-details>div>img{max-width:120px;margin:20px 20px 0 0;}.title-details p{margin:0 0 5px}"
        }
        else{
          style=".page-header{min-height:80px;}";
        }
        var content1 =
          "<html><head><title></title><style>" +
          self.$t("fonts") +
          style +
          ".page-header .clinic-logo-hold{top:-10px;left:20px;position:absolute} .tox.tox-tinymce{display:none!important} table.listview-table {font-family: arial, sans-serif;font-size: 14px;border-collapse: collapse;width: 100%;}table.listview-table th {border-top: 1px solid #666666;border-bottom: 1px solid #666666;text-align: left;padding: 3px 15px;}table.listview-table td {border: 0;text-align: left;padding: 5px;}table.listview-table tr:nth-child(even) {background-color: #fafafa;}.page-header,.page-header-space{height:20px}.page-header-space{margin-top:30px}.page-header-nospace{height:10px}.page-footer,.page-footer-nospace,.page-footer{width:100%;border-top:1px solid #d4d5d7}.page-header{width:100%;border-bottom:1px solid #000}@page{size:A4;margin:.5in}@media print{thead{display:table-header-group}tfoot{display:table-footer-group}button{display:none}body{margin:0}}</style></head><body>" +
          document.getElementById("consolidatedprintDiv")
            .innerHTML +
          "</body></html>";

        var data = { data: content1, prefix: "empty" };
        var config = {
          method: "post",
          url: process.env.VUE_APP_HTML_TO_PDF_CLINICAL_NOTES_API,
          headers: {
            "Content-Type": "application/json",
            x_tenant_id: localStorage.tenantid,
          },
          data: data,
        };
        self.$parent.loadstatusmessage("An email is on the way", false);
        Axios(config)
          .then(function (response) {
            console.clear();
            console.log(JSON.stringify(response.data));
            self.sendNotification(response.data);
            self.$parent.showhideemailpopup = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    sendNotification(urldata) {
      
      var mobile1 =
        this.prescriptionobj.patientdetails.country_code +
        this.prescriptionobj.patientdetails.mobile;
      var appid = this.$parent.appointmentdetails.unique_id;
      let data = {
        url: urldata.url,
        emailids: this.emaillist,
        mobile: mobile1,
        appid: appid,
      };
      var self = this;
      var role_unique_id =
        JSON.parse(localStorage.loggedInUserInfo).role &&
        JSON.parse(localStorage.loggedInUserInfo).role.unique_id
          ? JSON.parse(localStorage.loggedInUserInfo).role.unique_id
          : "";
      var suburl = "/notification";
      let axiosconfig = {
        method: "post",
        url: rest_service.baseURL + suburl + "/secnn",
        headers: {
          x_tenant_id: localStorage.tenantid,
          role_unique_id: role_unique_id,
          loggedin_user_unique_id: JSON.parse(localStorage.loggedInUserInfo)
            .unique_id,
          route_entity_name: suburl,
          Authorization: localStorage.accesstoken,
        },
        data: data,
      };
      Axios(axiosconfig)
        .then((response) => {
          if (response && response.data && response.data.result) {
            self.$parent.loadstatusmessage(
              "Email has been sent successfully",
              false
            );
            self.$parent.showhideemailpopup = false;
            self.resetEmailparams();
          }
        })
        .catch(function (error) {
          console.log(error);
          self.$parent.loadstatusmessage("Something went wrong", true);
          self.$parent.showhideemailpopup = false;
        });
    },
    onPrintPrescription() {
      debugger
      var content = document.getElementById(
        "consolidatedprintDiv"
      ).innerHTML;

      var mywindow = window.open(
          "",
          "PrintWindow",
          `width=${screen.width},height=${screen.height},top=0,left=0`
      );

      mywindow.document.write(`
          <html>
          <head>
          <title></title>
          <style>
          body {
          margin: 0;
          }
          .page-header .clinic-logo-hold {
            top: -10px;
            left: 20px;
            position:absolute;
          }
          .tox.tox-tinymce{display:none!important}
          .no-header{height:0;}
          table.listview-table {
          font-family: arial, sans-serif;
          font-size: 14px;
          border-collapse: collapse;
          width: 100%;
          }
          table.listview-table th {
          border-top: 1px solid #666666;
          border-bottom: 1px solid #666666;
          text-align: left;
          padding: 3px 15px;
          }
          table.listview-table td {
          border: 0;
          text-align: left;
          padding: 5px;
          }
          table.listview-table tr:nth-child(even) {
          background-color: #fafafa;
          }
          #consolidatedprintDiv {
          page-break-after: auto;
          }
          .page-header, .page-footer {
          height: auto;
          border: 0;
          }
          .page-header{
            min-height:80px;
          }
          @page {
          size: A4;
          margin: 0.5in;
          }
          @media print {
          thead {
          display: table-header-group;
          }
          tfoot {
          display: table-footer-group;
          }
          button {
          display: none;
          }
          body {
          margin: 0;
          }
          }
          </style>
          </head>
          <body>
          ${content}
          </body>
          </html>
          `);

      mywindow.focus();
      mywindow.print();
      mywindow.close();

    },
    onPrintConsolidated() {
      debugger;

      const containerId = "consolidatedprintDiv";
      const originalContent = document.getElementById(containerId).innerHTML;

      const userinfo = JSON.parse(localStorage.loggedInUserInfo || "{}");
      const selectedLang =
        userinfo &&
          userinfo.selected_prescription_language &&
          userinfo.selected_prescription_language.languageCode
          ? userinfo.selected_prescription_language.languageCode
          : "en";

      const mywindow = window.open(
        "",
        "PrintWindow",
        `width=${screen.width},height=${screen.height},top=0,left=0`
      );
      const decodeHTML = str => {
        const txt = document.createElement("textarea");
        txt.innerHTML = str;
        return txt.value;
      };

      const writeAndPrint = content => {

        let styleBlock = "";

        if (this.headerdisplaysetting == "hospital") {

          styleBlock = `
      body{margin:0;}

    .title-details{
      display:flex;
      grid-gap:60px;
      text-align:center;
      align-items:center;
    }

    .title-details>div>img{
      max-width:120px;
    }

    .title-details p{
      margin:0 0 5px;
    }

    .no-header{height:150px;}

    table.listview-table{
      font-family:arial,sans-serif;
      font-size:14px;
      border-collapse:collapse;
      width:100%;
    }

    table.listview-table th{
      border-top:1px solid #666666;
      border-bottom:1px solid #666666;
      text-align:left;
      padding:3px 15px;
    }

    table.listview-table td{
      border:0;
      text-align:left;
      padding:5px;
    }

    table.listview-table tr:nth-child(even){
      background-color:#fafafa;
    }

    .page-header{
      width:100%;
      border-bottom:1px solid #000;
    }

    .page-footer{
      position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: auto !important;
    min-height: 110px;
    padding: 10px 0;
    background: #fff;
    border-top: 1px solid #d4d5d7;
    }
    .page-footer table {
    width: 100%;
    border-collapse: separate !important;
    border-spacing: 0;
}
.page-footer td {
    text-align: center;
    vertical-align: middle;
    padding: 5px 0;
}
    .page-footer span,
.page-footer a,
.page-footer div {
    display: inline-block;
    line-height: 20px !important;
    white-space: normal !important;
    word-break: break-word;
    overflow-wrap: break-word;
}
#label_footer_disclaimer {
    display: block !important;
    width: 90%;
    margin: 0 auto 8px;
    line-height: 22px !important;
    font-size: 13px !important;
    font-weight: 500;
}
    * {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
}

.page-footer * {
    transform: none !important;
    letter-spacing: normal !important;
}
    @page{
      size:A4;
      margin:0.5in;
    }

    @media print{
      thead{display:table-header-group;}
      tfoot{display:table-footer-group;}
      button{display:none;}
      body{margin:0;}
    }

    `;

        } else {

          styleBlock = `
      body{margin:0;}

    .no-header{height:150px;}

    table.listview-table{
      font-family:arial,sans-serif;
      font-size:14px;
      border-collapse:collapse;
      width:100%;
    }

    table.listview-table th{
      border-top:1px solid #666666;
      border-bottom:1px solid #666666;
      text-align:left;
      padding:3px 15px;
    }

    table.listview-table td{
      border:0;
      text-align:left;
      padding:5px;
    }

    table.listview-table tr:nth-child(even){
      background-color:#fafafa;
    }

    @page{
      size:A4;
      margin:0.5in;
    }

    @media print{
      thead{display:table-header-group;}
      tfoot{display:table-footer-group;}
      button{display:none;}
      body{margin:0;}
    }
    `;

        }

        mywindow.document.write(`
    <html>
    <head>
    <title></title>
    <style>
    ${styleBlock}
    </style>
    </head>
    <body>
      ${content}
    </body>
    </html>
  `);

        mywindow.focus();
        mywindow.print();
        mywindow.close();
      };
      if (selectedLang === "en") {
        writeAndPrint(originalContent);
        return;
      }
      try {
        const inputdata = this.buildConsolidatedTranslateInput();

        if (!inputdata || Object.keys(inputdata).length === 0) {
          console.warn("No translatable content found. Printing English.");
          writeAndPrint(originalContent);
          return;
        }
        const originalLogoImg = document.querySelector("#" + containerId + " .clinic-logo-hold img");
        const logoSrc = originalLogoImg ? originalLogoImg.src : null;

        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = originalContent;

        if (logoSrc) {
          const clonedLogoImg = tempDiv.querySelector(".clinic-logo-hold img");
          if (clonedLogoImg) {
            clonedLogoImg.src = logoSrc;
          }
        }

        const textArray = Object.values(inputdata);
        const keysArray = Object.keys(inputdata);
        const chunkSize = 128;

        const textChunks = [];
        for (let i = 0; i < textArray.length; i += chunkSize) {
          textChunks.push(textArray.slice(i, i + chunkSize));
        }

        const translateChunk = chunk => {
          return Axios.post(
            "https://translation.googleapis.com/language/translate/v2?key="+process.env.VUE_APP_GOOGLETRANSLATEKEY,
            {
              q: chunk,
              target: selectedLang
            }
          ).then(res =>
            res.data.data.translations.map(t => t.translatedText)
          );
        };

        Promise.all(textChunks.map(translateChunk))
          .then(results => {
            const translatedTexts = results.flat();

            const decodeHTML = str => {
              const txt = document.createElement("textarea");
              txt.innerHTML = str;
              return txt.value;
            };

            keysArray.forEach((key, index) => {
              const el = tempDiv.querySelector(`#${key}`);
              if (el && translatedTexts[index]) {
                el.innerText = decodeHTML(translatedTexts[index]);
              }
            });

            const finalContent =
              originalContent +
              `<div style="page-break-before:always;"></div>` +
              tempDiv.innerHTML;

            writeAndPrint(finalContent);
          })
          .catch(err => {
            console.error("Translation failed. Printing English.", err);
            writeAndPrint(originalContent);
          });


      } catch (err) {
        console.error("Unexpected error. Printing English.", err);
        writeAndPrint(originalContent);
      }
    },

    buildConsolidatedTranslateInput() {
      let inputdata = {};

      const safeText = id => {
        const el = document.getElementById(id);
        return el ? el.innerText.trim().replace(/\s+/g, " ") : "";
      };

      /* =========================
       * PATIENT LABELS + VALUES
       * ========================= */
      inputdata.label_patientname = safeText("label_patientname");
      inputdata.value_patientname = safeText("value_patientname");

      inputdata.label_registrationno = safeText("label_registrationno");
      inputdata.label_agesex = safeText("label_agesex");
      inputdata.label_date = safeText("label_date");
      inputdata.label_doctorname = safeText("label_doctorname");
      inputdata.label_sign_doctorname = safeText("label_sign_doctorname");

      /* =========================
       * SECTION HEADERS
       * ========================= */
      inputdata.label_symptoms_summary = safeText("label_symptoms_summary");
      inputdata.label_chiefcomplaints_header = safeText("label_chiefcomplaints_header");
      inputdata.label_icd10 = safeText("label_icd10");
      inputdata.label_prescription_header = safeText("label_prescription_header");
      inputdata.label_investigations_header = safeText("label_investigations_header");
      inputdata.label_immunization_header = safeText("label_immunization_header");

      /* =========================
       * SYMPTOMS & SUMMARY
       * ========================= */
      inputdata.label_symptoms = safeText("label_symptoms");
      inputdata.value_symptoms = safeText("value_symptoms");

      inputdata.label_summary = safeText("label_summary");
      inputdata.value_summary = safeText("value_summary");

      /* =========================
       * CHIEF COMPLAINTS
       * ========================= */
      inputdata.label_chiefcomplaints = safeText("label_chiefcomplaints");
      inputdata.value_chiefcomplaints = safeText("value_chiefcomplaints");

      /* =========================
       * ICD10 (DESCRIPTIONS ONLY)
       * ========================= */
      if (Array.isArray(this.problemsandillnesslist)) {
        this.problemsandillnesslist.forEach((item, i) => {
          if (Array.isArray(item.selected_code)) {
            item.selected_code.forEach((_, j) => {
              const id = `icd_desc_${i}_${j}`;
              const text = safeText(id);
              if (text) inputdata[id] = text;
            });
          }
        });
      }

      /* =========================
       * PRESCRIPTION TABLE HEADERS
       * ========================= */
      inputdata.label_medicine_name = safeText("label_medicine_name");
      inputdata.label_dosage = safeText("label_dosage");
      inputdata.label_duration = safeText("label_duration");

      /* =========================
       * PRESCRIPTION MEDICINES
       * ========================= */
      if (this.prescriptionobj.modalresultPrescriptions) {
        this.prescriptionobj.modalresultPrescriptions.forEach((_, index) => {

          // Medicine name
          const medNameId = `med_name_${index}`;
          if (safeText(medNameId)) inputdata[medNameId] = safeText(medNameId);

          // Duration
          const durationId = `med_duration_${index}`;
          if (safeText(durationId)) inputdata[durationId] = safeText(durationId);

          // Food instruction
          const foodId = `med_food_${index}`;
          if (safeText(foodId)) inputdata[foodId] = safeText(foodId);

          // Dosage timings (ALL)
          [
            "med_dosage_morning_",
            "med_dosage_afternoon_",
            "med_dosage_evening_",
            "med_dosage_night_",
            "med_dosage_sos_"
          ].forEach(prefix => {
            const id = `${prefix}${index}`;
            if (safeText(id)) inputdata[id] = safeText(id);
          });
        });
      }

      /* =========================
       * INVESTIGATIONS
       * ========================= */
      if (this.investigationobj.modalresultInvestigation) {
        this.investigationobj.modalresultInvestigation.forEach((_, index) => {
          ["investigation_name_", "investigation_note_label_", "investigation_note_"]
            .forEach(prefix => {
              const id = `${prefix}${index}`;
              if (safeText(id)) inputdata[id] = safeText(id);
            });
        });
      }

      /* =========================
       * IMMUNIZATION HEADERS
       * ========================= */
      inputdata.label_vaccine_name = safeText("label_vaccine_name");
      inputdata.label_due_date = safeText("label_due_date");
      inputdata.label_route = safeText("label_route");
      inputdata.label_site = safeText("label_site");
      inputdata.label_note = safeText("label_note");

      /* =========================
       * IMMUNIZATION ROWS
       * ========================= */
      if (this.immunizationobj.modalresultImmunization) {
        this.immunizationobj.modalresultImmunization.forEach((_, index) => {
          ["vaccine_name_", "route_", "site_", "note_"].forEach(prefix => {
            const id = `${prefix}${index}`;
            if (safeText(id)) inputdata[id] = safeText(id);
          });
        });
      }

      /* =========================
       * FOOTER DISCLAIMER
       * ========================= */
      inputdata.label_footer_disclaimer = safeText("label_footer_disclaimer");

      return inputdata;
    },



    getUrlFromS3Bucket(bucketnameandkey) {
      var self = this;
      var suburl = "/S3Proxy";
      rest_service
        .downloadFromS3Bucket(suburl, this.tenantId, bucketnameandkey)
        .then(function (response) {
          if (response != null && response.data != null) {
            self.getdownloadfileUrl = response.data.result;
            var url_string = response.data.result;
            var url = new URL(url_string);
            var timestamp = url.searchParams.get("Expires");
            timestamp = Math.floor(timestamp * 1000);
            var ExpiryDateTime = new Date(timestamp);
            localStorage.setItem("SignatureExpiryDate", ExpiryDateTime);
            localStorage.setItem("SignatureUrl", self.getdownloadfileUrl);
          } else {
            return null;
          }
        })
        .catch(function (error) {
          return error;
        })
        .finally(() => {
          this.isrefreshpre = false;
        });
    },
    getstaffbyid(id) {
      var self = this;
      var suburl = "/staff";
      rest_service
        .getbyid(suburl, id, this.prescriptionobj.tenant_id, "get?id=" + id)
        .then(function (response) {
          if (response != null && response.data != null) {
            self.prescriptionobj.staffDetails = response.data.result;
            self.setCategory();
          } else {
            return null;
          }
        })
        .catch(function (error) {
          return error;
        });
    },
    getpatientdetails: function (patientid) {
      var currenttenant = localStorage.getItem("tenantid");
      var self = this;
      rest_service
        .getPatientInfo("/patient", this.prescriptionobj.tenant_id, patientid)
        .then((respo) => {
          if (respo.data && respo.data.result) {
            respo.data.result = JSON.parse(respo.data.result);
            if (respo.data.result.Date_of_birth) {
              self.ageCalculated = commonhelper.getAge(
                respo.data.result.Date_of_birth
              );
            } else if (respo.data.result.age) {
              self.ageCalculated = respo.data.result.age + " yrs";
            } else {
              self.ageCalculated = "N/A";
            }

            if (respo.data.result.tenant_map) {
              respo.data.result.tenant_map.forEach((element) => {
                if (element.tenant_id == currenttenant) {
                  self.prescriptionobj.patientdetails.patient_RegId =
                    element.patient_RegId;
                }
              });
            }

            // self.emaillist.push(self.prescriptionobj.patientdetails.email.toLowerCase());
          }
        })
        .catch(function (error) {
          return error;
        });
    },
    getSignature: function () {
      this.foldername =
        this.tenantId +
        this.$store.state.helper.patient_s3upload_Folders
          .scanReportDownloadPath +
        item;
    },
    // show() {
    //   this.showModal = true;
    // },
    hide() {
      this.showModal = false;
    },
    getQRCode() {
      rest_service.getQRCodeData();
      return this.$store.state.helper.qrcodeimagestr;
    },
    setCategory() {
      var self = this;
      if (
        self.prescriptionobj.staffDetails &&
        self.prescriptionobj.staffDetails.specialization
      ) {
        self.prescriptionobj.staffDetails.category =
          self.prescriptionobj.staffDetails.specialization;
      }
    },
    getPrescriptionStaticContent(staffId) {
      if (staffId) {
        rest_service.getPrescriptionStaticContent(staffId).then((respo) => {
          this.prescriptionFooterNote1 = respo;
        });
      }
    },
  },
};
</script>
<style>
  #consolidatedprintDiv .tox.tox-tinymce {
    display: none !important;
}
</style>
<style scoped>

#consolidatedprintDiv .tox.tox-tinymce {
    display: none !important;
}
#consolidatedprintDiv table thead tr {
  background: #fff;
  border: 0 !important;
}
div#prescriptionFooterNote1 table {
  width: 100%;
}
.prescriptionFooterNotehold table tbody {
  border: none;
}
.page-header {
  position: static;
  width: 100%;
  height: auto;
}
.page-header .clinic-logo-hold {
  top: 0 !important;
  left: 2rem !important;
}
.page-header-space {
  height: auto;
}

table.listview-table {
  font-family: arial, sans-serif;
  font-size: 14px;
  border-collapse: collapse;
  width: 100%;
}
table.listview-table th {
  border-top: 1px solid #666666;
  border-bottom: 1px solid #666666;
  text-align: left;
  padding: 3px 15px;
}
table.listview-table td {
  border: 0;
  text-align: left;
  padding: 5px;
}

table.listview-table tr:nth-child(even) {
  background-color: #fafafa;
}
.close-sec-hold {
    right: 0 !important;
    top: -30px;
}
</style>
